import {z} from 'zod';

import {WeekDaysEnum} from '../../provider/locale/locale-context-const';

export const workloadSchema = z.record(z.nativeEnum(WeekDaysEnum), z.record(z.number(), z.number()).optional());

export type WorkloadByHoursAndWeekDaysType = z.infer<typeof workloadSchema>;
